import { Container } from "react-bootstrap";
import BreadCrumb from "../src/components/Shared/BreadCrumb";
import server from "../src/api/server";
import { useIntl } from "react-intl";
import SectionHead from "../src/components/Shared/SectionHead";
import { NextSeo } from "next-seo";

const AboutPage = ({ aboutData, error, breadBackground, metaDataSections }) => {
  error && console.log(JSON.parse(error));

  const { locale, formatMessage } = useIntl();
  const aboutMeta = metaDataSections?.find((item) => item?.slug === "about");

  return (
    <>
      <NextSeo
        title={null || formatMessage({ id: aboutMeta?.slug })}
        description={
          aboutMeta?.description[locale] ||
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="about-page">
        <BreadCrumb
          title={formatMessage({ id: "aboutUs" })}
          pageTitle={formatMessage({ id: "projects" })}
          breadBackground={breadBackground}
        />
        <div className="about-page-body">
          <div className="about-s">
            <div className="about-bottom">
              <Container>
                <div className="mb-5">
                  <SectionHead
                    title={formatMessage({
                      id: "company-about",
                    })}
                  />

                  <div
                    className="teamMembers-about"
                    dangerouslySetInnerHTML={{
                      __html:
                        aboutData[0]?.aboutUs?.description[locale] ||
                        "loading...",
                    }}
                  ></div>
                </div>
                <div>
                  <SectionHead
                    title={formatMessage({
                      id: "services",
                    })}
                  />

                  <div
                    className="teamMembers-about"
                    dangerouslySetInnerHTML={{
                      __html: aboutData?.[0]?.services?.description?.[locale],
                    }}
                  />
                </div>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const aboutResponse = await server.get("/pages/about-us");
    const metaResponse = await server.get("/pages/metaData");
    const teamMembersResponse = await server.get(
      "/pages/teamMembers/sections/teamMembers"
    );
    let breadBack, testmonialsBack;
    try {
      const backgroundResponse = await server.get("/pages/backgrounds");
      breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "breadcrumbs"
      )?.image;
      testmonialsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "testmonials"
      )?.image;
    } catch (err) {
      console.log(err);
    }

    return {
      revalidate: 60,
      props: {
        aboutData: aboutResponse.data.data.page.sections,
        metaDataSections: metaResponse?.data?.data?.page?.sections,
        teamMembersSection: teamMembersResponse?.data.data.section,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : "",
        testmonialsBack: testmonialsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${testmonialsBack}`
          : "",
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default AboutPage;
